import { render } from "./TheBusinessModel.vue?vue&type=template&id=2ff41ea7&scoped=true"
import script from "./TheBusinessModel.vue?vue&type=script&lang=js"
export * from "./TheBusinessModel.vue?vue&type=script&lang=js"

import "./TheBusinessModel.vue?vue&type=style&index=0&id=2ff41ea7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff41ea7"]])

export default __exports__